import * as React from 'react';
import { Link } from 'gatsby';
import { Row, Col } from 'react-bootstrap';

import './dashboard-footer.scss';

export const DashboardFooter: React.FC = () => {
  return (
    <div className="dashboard-footer">
      <Row>
        <Col sm="12" lg="6" className="left">
          <ul className="important-links">
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
          </ul>
        </Col>
        <Col sm="12" lg="6" className="right">
          <p>Copyright © 2025 Prydwen.gg</p>
        </Col>
      </Row>
    </div>
  );
};
